import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-contact-swiper',
  templateUrl: './contact-swiper.component.html',
  styleUrls: ['./contact-swiper.component.scss']
})
export class ContactSwiperComponent implements OnInit {

  showContact: boolean = false;
  firstLoad: boolean = true;
  constructor() { }

  ngOnInit(): void {
  }

  hideOrShowContact(): void{
    this.firstLoad = false;
    this.showContact = !this.showContact;
  }

}
